<template>
  <div class="w-full" id="WorkAndFinances">
    <ValidationObserver ref="WorkAndFinances" v-slot="observer">
      <h2 data-prefix="3" class="mb-5 text-4xl font-semibold leading-7">Work and Finances</h2>
      <p class="text-m">We need to consider your ability to pay your debt so we can offer you the best credit limit. Your income is a key factor in order for us to make a decision, so it's important you're honest about this.</p>
      <div class="mt-5 mb-6">
        
        <ValidationProvider name="Employment Status" rules="required">
            <div slot-scope="{ errors }">

              <label class="font-semibold label">Employment Status
                <TickIcon class="tick-icon"/>
              </label>
              
              <!-- Employed -->
              <input tabindex="0" name="EM" v-model="employmentStatusCode" type="radio" id="EM" value="EM" />
              <label @keypress.enter.prevent="$event.target.click" :class="{ 'border-error': errors[0] }" class="text-xl border border-polgrey-medium label-select" for="EM">Employed
                <TickIcon class="tick-icon"/>
              </label>
              
              <!-- Self Emplopyed -->
              <input tabindex="0" name="SE" v-model="employmentStatusCode" type="radio" id="SE" value="SE" />
              <label @keypress.enter.prevent="$event.target.click" :class="{ 'border-error': errors[0] }" class="text-xl border border-polgrey-medium label-select" for="SE">Self Employed
                <TickIcon class="tick-icon"/>
              </label>
              
              <!-- Homemaker -->
              <input tabindex="0" name="HO" v-model="employmentStatusCode" type="radio" id="HO" value="HO" />
              <label @keypress.enter.prevent="$event.target.click" :class="{ 'border-error': errors[0] }" class="text-xl border border-polgrey-medium label-select" for="HO">Homemaker
                <TickIcon class="tick-icon"/>
              </label>
              
              <!-- Retired -->
              <input tabindex="0" name="RE" v-model="employmentStatusCode" type="radio" id="RE" value="RE" />
              <label @keypress.enter.prevent="$event.target.click" :class="{ 'border-error': errors[0] }" class="text-xl border border-polgrey-medium label-select" for="RE">Retired
                <TickIcon class="tick-icon"/>
              </label>
              
              <!-- Unemployed -->
              <input tabindex="0" name="UN" v-model="employmentStatusCode" type="radio" id="UN" value="UN" />
              <label @keypress.enter.prevent="$event.target.click" :class="{ 'border-error': errors[0] }" class="text-xl border border-polgrey-medium label-select" for="UN">Unemployed
                <TickIcon class="tick-icon"/>
              </label>
              
              <!-- Student -->
              <input tabindex="0" name="ST" v-model="employmentStatusCode" type="radio" id="ST" value="ST" />
              <label @keypress.enter.prevent="$event.target.click" :class="{ 'border-error': errors[0] }" class="text-xl border border-polgrey-medium label-select" for="ST">Student
                <TickIcon class="tick-icon"/>
              </label>

              <p :class="{ 'pt-2': errors[0] }" class="text-polred">{{ errors[0] }}</p>
            </div>
          </ValidationProvider>

      </div>
      <div class="mb-4 -mx-3">

        <div class="w-full px-3 mb-4 md:w-2/6 md:mb-0">
          <!-- Occupation -->
          <label class="font-semibold label" for="occupation">Occupation (Optional)</label>
          <ValidationProvider name="Occupation" :rules="occupationRules">
            <div slot-scope="{ errors }">
              <input tabindex="0" placeholder="e.g. Teacher" :class="{ 'border-error': errors[0] }" v-model.trim="occupation" class="placeholder-polgrey-dark input" id="occupation" type="text">
              <p class="text-polred">{{ errors[0] }}</p>
            </div>
          </ValidationProvider>
        </div>
        
        <div class="w-full px-3 my-8 md:w-full">
          
          <p class="font-semibold label">How many people are financially dependent on you?</p>
          
          <!-- 0 Dependents -->

          <ValidationProvider name="Number of dependents" rules="required">
            <div slot-scope="{ errors }">

              <div class="flex">
                <input name="dep-0" v-model.number="numberOfDependents" type="radio" id="dep-0" value="0" />
                <label tabindex="0" @keypress.enter.prevent="$event.target.click" :class="{ 'border-error': errors[0] }" class="rounded-l-full dependent-label text-l" for="dep-0">0
                  <TickIcon class="tick-icon"/>
                </label>
                
                <!-- 1 Dependents -->
                <input name="dep-1" v-model.number="numberOfDependents" type="radio" id="dep-1" value="1" />
                <label tabindex="0" @keypress.enter.prevent="$event.target.click" :class="{ 'border-error': errors[0] }" class="dependent-label text-l" for="dep-1">1
                  <TickIcon class="tick-icon"/>
                </label>
                
                <!-- 2 Dependents -->
                <input name="dep-2" v-model.number="numberOfDependents" type="radio" id="dep-2" value="2" />
                <label tabindex="0" @keypress.enter.prevent="$event.target.click" :class="{ 'border-error': errors[0] }" class="dependent-label text-l" for="dep-2">2
                  <TickIcon class="tick-icon"/>
                </label>
                
                <!-- 3 Dependents -->
                <input name="dep-3" v-model.number="numberOfDependents" type="radio" id="dep-3" value="3" />
                <label tabindex="0" @keypress.enter.prevent="$event.target.click" :class="{ 'border-error': errors[0] }" class="dependent-label text-l" for="dep-3">3
                  <TickIcon class="tick-icon"/>
                </label>
                
                <!-- 4 Dependents -->
                <input name="dep-4" v-model.number="numberOfDependents" type="radio" id="dep-4" value="4" />
                <label tabindex="0" @keypress.enter.prevent="$event.target.click" :class="{ 'border-error': errors[0] }" class="dependent-label text-l" for="dep-4">4
                  <TickIcon class="tick-icon"/>
                </label>
                
                <!-- 5+ Dependents -->
                <input name="dep-5" v-model.number="numberOfDependents" type="radio" id="dep-5" value="5+" />
                <label tabindex="0" @keypress.enter.prevent="$event.target.click" :class="{ 'border-error': errors[0] }" class="rounded-r-full dependent-label text-l" for="dep-5">5+
                  <TickIcon class="tick-icon"/>
                </label>

              </div>
              <!-- Error message -->
              <p class="mt-2 text-polred">
                {{ errors[0] }}
              </p>

            </div>
          </ValidationProvider>
        </div>
      </div>
      <div class="flex flex-wrap mb-4 -mx-3">
        <div class="w-full px-3 mb-4 md:w-auto md:mb-4">
          <label class="font-semibold label" for="incomePerYear">
            Income (per year before tax) 
            <HelpPopup key="incomePerYear" text="Your income includes your salary, pension and any other benefits you receive."/>
          </label>
          <!-- Income Per Year -->
          <ValidationProvider name="Income per year" rules="required|decimal">
            <div class="w-full lg:w-6/6" slot-scope="{ errors }">
              <input tabindex="0" placeholder="e.g. 26000" :class="{ 'border-error': errors[0] }" v-model.trim="incomeAmount" class="placeholder-polgrey-dark input focus:outline-none" id="incomePerYear" type="number">
              <p class="text-polred">{{ errors[0] }}</p>
            </div>
          </ValidationProvider>
        </div>
        <div class="w-full px-3 md:w-auto">
          <label class="font-semibold label" for="monthlyOutgoings">How much of your income is spent monthly on mortgages/rent?
            <HelpPopup key="incomePerYear" text="This includes your rent, monthly mortgage payment or a different kind of accommodation cost."/>
          </label>
          <!-- Monthly Outgoings -->
          <div class="w-full lg:w-3/6">
            <ValidationProvider name="Monthly outgoings" rules="required|decimal">
              <div class="w-full" slot-scope="{ errors }">
                <input tabindex="0" placeholder="e.g. 1000" :class="{ 'border-error': errors[0] }" v-model.trim="monthlyOutgoings" class="placeholder-polgrey-dark input focus:outline-none" id="monthlyOutgoings" type="number">
                <p class="text-polred">{{ errors[0] }}</p>
              </div>
            </ValidationProvider>
          </div>
        </div>
      </div>
      <div class="flex flex-wrap -mx-3">
        <div class="w-full px-3 mb-4 md:mb-6">

          <ValidationProvider name="Additional Income selection" rules="required">
            <div slot-scope="{ errors }">

              <p class="font-semibold label">
                In addition to your own income, are there other sources of income in your household?
              </p>

              <div class="flex">
        
              <label @keypress.enter.prevent="$event.target.click" tabindex="0" class="mr-4 checkbox-label">
                <div :class="{ 'border-error': errors[0], 'bg-polgrey-dark border-polgrey-dark' : additionalIncomeIndicator == 'Y', }" class="flex inline-flex items-center justify-center w-6 h-6 p-1 mr-4 text-lg bg-white border rounded cursor-pointer border-polgrey-medium">
                  <input name="ukResidencyCode" value="Y" :aria-checked="`${additionalIncomeIndicator == 'Y'}`" v-model="additionalIncomeIndicator" true-value="Y" false-value="N" type="radio" class="hidden">
                  <TickIcon class="hidden w-6 h-6 pointer-events-none fill-current"/>
                </div>
                <div class="relative inline mr-2 select-none check-label"> Yes</div>
              </label>

              <label @keypress.enter.prevent="$event.target.click" tabindex="0" class="checkbox-label">
                <div :class="{ 'border-error': errors[0], 'bg-polgrey-dark border-polgrey-dark' : additionalIncomeIndicator == 'N', }" class="flex inline-flex items-center justify-center w-6 h-6 p-1 mr-4 text-lg bg-white border rounded cursor-pointer border-polgrey-medium">
                  <input name="additionalIncomeIndicator" value="N" :aria-checked="`${additionalIncomeIndicator == 'N'}`" v-model="additionalIncomeIndicator" true-value="Y" false-value="N" type="radio" class="hidden">
                  <TickIcon class="hidden w-6 h-6 pointer-events-none fill-current"/>
                </div>
                <div class="relative inline mr-2 select-none check-label"> No</div>
              </label>
              </div>

              <div v-if="additionalIncomeIndicator == 'Y'" class="w-4/6 mt-6">
                <!-- additional income amount -->
                <p class="font-semibold label" for="otherHouseholdIncome"> What is this additional income per year, before tax? </p>
                <ValidationProvider name="What is this additional income per year, before tax?" ref="otherHouseholdIncome" rules="required|decimal">
                  <div slot-scope="{ errors }">
                  <div class="w-2/6">
                    <input tabindex="0" v-model.trim.number="otherHouseholdIncome" :class="{ 'border-error': errors[0] }" class="input focus:outline-none" id="otherHouseholdIncome" type="number">
                  </div>
                  <p class="text-polred">{{ errors[0] }}</p>
                  </div>
                </ValidationProvider>
              </div>

              <p :class="{ 'pt-2': errors[0] }" class="text-polred">{{ errors[0] }}</p>
            </div>
          </ValidationProvider>

        
        </div>
        <div class="w-full px-3">

          <ValidationProvider name="Cash Advance selection">
            <div slot-scope="{ errors }">

              <!-- Are you a UK Resident? -->
              <p class="font-semibold label">
                Are you interested in taking a cash advance?
                <HelpPopup key="cashAdvanceIndicator" text="Cash advance allows you to immediately make cash withdrawals from an ATM."/>
              </p>

              <div class="flex">
        
              <label @keypress.enter.prevent="$event.target.click" tabindex="0" class="mr-4 checkbox-label">
                <div :class="{ 'border-error': errors[0], 'bg-polgrey-dark border-polgrey-dark' : cashAdvanceIndicator == 'Y', }" class="flex inline-flex items-center justify-center w-6 h-6 p-1 mr-4 text-lg bg-white border rounded cursor-pointer border-polgrey-medium">
                  <input name="cashAdvanceIndicator" value="Y" v-model="cashAdvanceIndicator" true-value="Y" false-value="N" type="radio" class="hidden">
                  <TickIcon class="hidden w-6 h-6 pointer-events-none fill-current"/>
                </div>
                <div class="relative inline mr-2 select-none check-label"> Yes</div>
              </label>

              <label @keypress.enter.prevent="$event.target.click" tabindex="0" class="checkbox-label">
                <div :class="{ 'border-error': errors[0], 'bg-polgrey-dark border-polgrey-dark' : cashAdvanceIndicator == 'N', }" class="flex inline-flex items-center justify-center w-6 h-6 p-1 mr-4 text-lg bg-white border rounded cursor-pointer border-polgrey-medium">
                  <input name="cashAdvanceIndicator" value="N" v-model="cashAdvanceIndicator" true-value="Y" false-value="N" type="radio" class="hidden">
                  <TickIcon class="hidden w-6 h-6 pointer-events-none fill-current"/>
                </div>
                <div class="relative inline mr-2 select-none check-label"> No</div>
              </label>
              </div>
              <p :class="{ 'pt-2': errors[0] }" class="text-polred">{{ errors[0] }}</p>
            </div>
          </ValidationProvider>
        </div>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>

import TickIcon from '@/v2/assets/images/icons/select-tick.svg'
import HelpPopup from '@/v2/components/elements/HelpPopup'

import { mapFields } from 'vuex-map-fields'

export default {
  name: 'WorkAndFinances',
  computed : {
    ...mapFields([
      'person.employmentStatusCode',
      'person.additionalIncomeIndicator',
      'person.incomeAmount',
      'person.numberOfDependents',
      'person.occupation',
      'person.monthlyOutgoings',
      'person.cashAdvanceIndicator',
      'person.otherHouseholdIncome'
    ]),
  },
  watch: {
    occupation: {
      immediate: true,
      async handler() {
        this.occupationRules = this.occupation.length ? 'required|min:1|max:32' : ''
      }
    },
  },
  components: {
    TickIcon,
    HelpPopup
  },
  data() {
    return {
      occupationRules: '',
    }
  },
}
</script>

<style scoped>

</style>
